import React from 'react'
import { Description, EmptySummary, Layout, Result, Year, YearSummary } from './styles'
import { CHECK_UP_YEARS_QUANTITY, EMPTY_MEASUREMENT, EMPTY_MEASUREMENT_TEXT } from '~/constants/checkUp'
import { transformDate } from '~/utils'

import { Tooltip } from '~/components/shared/tooltip'
import { CheckUpPropertyMeasurement } from '~/interfaces'

// =======================

interface EmptyRegisterProps {
  children: string
}

const EmptyRegister = ({ children }: EmptyRegisterProps): JSX.Element => (
  <Tooltip opacity={0.8} description={'Não possui registro para este período'}>
    <EmptySummary>{children}</EmptySummary>
  </Tooltip>
)

// =======================

interface FilledRegisterProps {
  children: string
  isAltered: boolean
  dateToYear: string
}

const FilledRegister = ({ children, isAltered, dateToYear }: FilledRegisterProps): JSX.Element => (
  <YearSummary isAltered={isAltered}>
    <Year>{transformDate({ date: dateToYear, dateFormat: 'yyyy' })}</Year>
    <Result>{children}</Result>
  </YearSummary>
)

// =======================

const fixPropertyMeasurementLength = (measurements: CheckUpPropertyMeasurement[]) => {
  const fixedMeasurements = measurements.slice(0, CHECK_UP_YEARS_QUANTITY)

  if (fixedMeasurements.length < CHECK_UP_YEARS_QUANTITY) {
    return fixPropertyMeasurementLength([EMPTY_MEASUREMENT, ...fixedMeasurements])
  }
  return fixedMeasurements
}

interface HistoryProps {
  measurements: CheckUpPropertyMeasurement[]
}

export const History = ({ measurements }: HistoryProps): JSX.Element => (
  <Layout>
    <Description>Histórico</Description>

    {fixPropertyMeasurementLength(measurements).map(({ date, isAltered, value }, index) => {
      if (value === EMPTY_MEASUREMENT_TEXT) return <EmptyRegister key={index}>{value}</EmptyRegister>

      return (
        <FilledRegister key={date} dateToYear={date} isAltered={isAltered}>
          {value}
        </FilledRegister>
      )
    })}
  </Layout>
)
